/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TChatsBulkOperationsReadDesktopModel,
  IChatsBulkOperationsReadDesktopRequest,
  IMappers,
  IChatsBulkOperationsReadDesktopResponse,
  IChatsBulkOperationsReadDesktopResponseError,
  TChatsBulkOperationsReadDesktopResponse,
} from './types';

const defaultConfig: TChatsBulkOperationsReadDesktopModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'chats',
  pathApi: '/v1/chats/bulk-operations/read-desktop/',
  hostType: 'api',
} as TChatsBulkOperationsReadDesktopModel;

function createChatsBulkOperationsReadDesktopModel(
  parameters: IChatsBulkOperationsReadDesktopRequest,
): TChatsBulkOperationsReadDesktopModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IChatsBulkOperationsReadDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IChatsBulkOperationsReadDesktopRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchChatsBulkOperationsReadDesktop<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IChatsBulkOperationsReadDesktopOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TChatsBulkOperationsReadDesktopResponse
> {
  const { response, statusCode } = await httpApi.fetch(createChatsBulkOperationsReadDesktopModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IChatsBulkOperationsReadDesktopResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IChatsBulkOperationsReadDesktopResponseError);
    }
  }

  return { response, statusCode } as TChatsBulkOperationsReadDesktopResponse;
}

export { defaultConfig, createChatsBulkOperationsReadDesktopModel, fetchChatsBulkOperationsReadDesktop };
